// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'core-js/es6/promise'
import 'core-js/es6/string'
import 'core-js/es7/array'
// import cssVars from 'css-vars-ponyfill'
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'
import VueLocalStorage from 'vue-localstorage'
import VeeValidate from 'vee-validate'
import VueResource from 'vue-resource'
import VuejsDialog from 'vuejs-dialog'
import VCalendar from 'v-calendar'
import Notifications from 'vue-notification'
import 'v-calendar/lib/v-calendar.min.css'
import VueTagsInput from '@johmun/vue-tags-input';
import { MultiSelectPlugin } from "@syncfusion/ej2-vue-dropdowns";
import { MultiSelect, CheckBoxSelection } from '@syncfusion/ej2-dropdowns';
import Paginate from 'vuejs-paginate';
import VueQRCodeComponent from 'vue-qrcode-component'
import Multiselect from 'vue-multiselect';
import VueSidebarMenu from 'vue-sidebar-menu'
import 'vue-sidebar-menu/dist/vue-sidebar-menu.css'
import { CheckBox, ChangeEventArgs } from '@syncfusion/ej2-buttons';
import VueSimpleAlert from "vue-simple-alert";
// todo
// cssVars()
Vue.use(MultiSelectPlugin);
Vue.config.silent = true;
Vue.use(VueLocalStorage)
Vue.use(BootstrapVue)
Vue.component('paginate', Paginate)
Vue.use(Notifications)
Vue.use(VueSidebarMenu)
Vue.component('qr-code', VueQRCodeComponent)
 Vue.component('multiselect', Multiselect)
Vue.use(VeeValidate, {
  inject: true,
  fieldsBagName: 'veeFields'
});
Vue.use(VueResource)

let sessionExpired = false;
const LOGIN_PATH = '/login';

// Reset flag after navigation actually reaches login
router.afterEach((to) => {

  if (to.path && to.path.includes(LOGIN_PATH)) {
    console.log('Login route reached - resetting sessionExpired');

    sessionExpired = false;
  }

});


Vue.http.interceptors.push((request, next) => {

  next((response) => {

    const body = response.body || {};

    if (
      body.status === "403" ||
      body.returnvalue === "Invalid Token!"
    ) {

      // -----------------------------------------
      // Already on login page
      // Don't alert or redirect again
      // -----------------------------------------
      if (
        router.currentRoute.path &&
        router.currentRoute.path.includes(LOGIN_PATH)
      ) {
        return response;
      }

      // -----------------------------------------
      // Already handling session expiry
      // Ignore other API responses
      // -----------------------------------------
      if (sessionExpired) {
        return response;
      }

      // -----------------------------------------
      // Set flag BEFORE redirect
      // -----------------------------------------
      sessionExpired = true;

      // -----------------------------------------
      // Clear session
      // -----------------------------------------
      localStorage.clear();

      // -----------------------------------------
      // Show alert only once
      // -----------------------------------------
      alert(
        "Your session has expired or you have logged in from another device. Please login again."
      );

      // -----------------------------------------
      // Redirect to login
      // -----------------------------------------
      router.replace(LOGIN_PATH).catch((err) => {

        // Ignore duplicate navigation error
        if (
          err &&
          err.name === 'NavigationDuplicated'
        ) {
          return;
        }

        console.error('Login redirect failed:', err);
      });

      // IMPORTANT:
      // Do NOT do:
      //
      // sessionExpired = false;
      //
      // here.
      //
      // afterEach() will reset it when /login
      // is actually reached.

      return response;
    }

    return response;
  });

});


Vue.use(VuejsDialog)
Vue.use(VCalendar)
Vue.use(VueTagsInput);
Vue.use(MultiSelectPlugin);
MultiSelect.Inject(CheckBoxSelection);
Vue.use(VueSimpleAlert);






/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: {
    App
  }
})
